import { forwardRef, ReactNode } from "react";
import { Box, Card, CardContent, CardHeader, Paper } from "@mui/material";
import { SxProps, Theme, useTheme } from "@mui/material/styles";

interface Props {
	header?: ReactNode;
	content: ReactNode;
	sxContent?: SxProps<Theme>;
	elevation?: number;
}

/**
 * PaperCard is the component that is used to render the container of all the cards
 *
 *
 * @param children a ReactNode, usually a view
 * @param title    the widget container view
 * @returns        a card that renders a title and some content, usually data in form or chart form
 */
const PaperCard = forwardRef<HTMLDivElement, Props>(({ header, content, sxContent, elevation = 3 }, ref) => {
	const theme = useTheme();

	return (
		<Paper ref={ref} elevation={elevation} sx={{ height: "100% !important", backgroundColor: "trasparent" }}>
			<Card sx={{ p: 0 }}>
				<CardHeader title={header} sx={{ color: theme.palette.primary.main }}></CardHeader>
				<CardContent sx={{ flexGrow: 4 }}>
					<Box
						sx={{
							width: "100%",
							height: "100%",
							flexGrow: 4,
							paddingRight: 2,
							paddingBottom: 2,
							paddingLeft: 2,
							...sxContent,
						}}
					>
						{content}
					</Box>
				</CardContent>
			</Card>
		</Paper>
	);
});

export default PaperCard;
